<template>
  <base-input
    class="ps-w-full focus:ps-border-b-2 ps-border-solid ps-bg-transparent ps-text-gray-900 ps-font-semibold ps-px-0 ps-h-20 ps-rounded-none ps-outline-none"
    :vuelidate="vuelidate"
    v-model="vuelidate.$model"
    :placeholder="placeholder"
    :options="options"
  />
</template>

<script>
import BaseInput from '@/components/inputs/BaseInput'

export default {
  name: 'InputUnderline',
  extends: BaseInput,
  components: {
    BaseInput
  }
}
</script>
